import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Basic from "./Components/Basic";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import InputLabel from "@material-ui/core/InputLabel";
import CustomInput from "components/CustomInput/CustomInput";
import LeftMenu from "./Components/Menu";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Taishou from "./Components/Taishou";
import { isEmptyObj, getErrors } from "../../../helpers/common";
import { useData } from "./hooks/useData";
import { toInt } from "./hooks/useComon";
import { useValidate } from "../../../hooks/useValidate";
import { fetchUpdateSetting, fetchUpdateSwitch } from "../../../services/api.zohoSetting";
import { userActions } from "../../../actions/user.actions";

export default function index() {
  const dispatch = useDispatch();
  const [isOpen, data, setData] = useData();
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [error, setError] = useState({});
  const [isProcess, setIsProcess] = useState(false);


  async function handleUpdate() {
    setIsLoadingBtn(true);
    const res = await fetchUpdateSetting(data, dispatch);
    setIsLoadingBtn(false);
    if (!res.isOk) {
      return setError(getErrors(res.errors.message));
    }
    setData(res.data.data);
  }

  function handleBindValue(e) {
    const { id, value } = e.target;
    const [isError, key, message] = useValidate(id, value);

    setError((state) => ({
      ...state,
      [key]: isError ? message : null,
      isError,
    }));

    setData((state) => ({ ...state, [key]: value }));
  }

  function enableBtn() {
    const { client_id, client_secret, refresh_token } = data;
    const isEmptyVal = isEmptyObj({ client_id, client_secret, refresh_token });

    return !(!error.isError && !isEmptyVal);
  }

  async function handleUpdateSwitch(obj) {
    const { id, checked } = obj;
    const newData = { ...data, [id]: checked };
    setData(newData);

    setIsProcess(true);
    const res = await fetchUpdateSwitch(toInt(newData), dispatch);
    setIsProcess(false);
    if (res.isOk) {
      const obj = Object.fromEntries(
        Object.entries(res.data.data)
          .map(([key, val]) => [key, !!parseInt(val)])
      );
      dispatch(userActions.updateUserInfo('user_kintone', obj));
    }
  }

  return (
    <>
      <Box className="backdrop">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
      <GridContainer spacing={3} direction="row">
        <GridItem xs={12} md={12} lg={3}>
          <LeftMenu />
        </GridItem>
        <GridItem xs={12} md={12} lg={9}>
          <Basic />
          <Card id="auth">
            <CardHeader>
              <h3 className="text-bold text-dark-grey">認証情報</h3>
            </CardHeader>
            <CardBody className="pt-0">
              <Box sx={{ mt: 3 }}>
                <GridContainer spacing={3} direction="row">
                  <GridItem xs={12}>
                    <InputLabel className="text-grey">クライアントID</InputLabel>
                    <CustomInput
                      success={isEmpty(error.client_id)}
                      error={!isEmpty(error.client_id)}
                      helperText={error.client_id}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        id: "client_id",
                        placeholder: "クライアントID",
                        onChange: (e) => handleBindValue(e),
                        maxLength: 255,
                        value: data.client_id ?? "",
                        type: "text",
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </Box>
              <Box sx={{ mt: 3 }}>
                <GridContainer spacing={3} direction="row">
                  <GridItem xs={12}>
                    <InputLabel className="text-grey">クライアント秘密キー</InputLabel>
                    <CustomInput
                      success={isEmpty(error.client_secret)}
                      error={!isEmpty(error.client_secret)}
                      helperText={error.client_secret}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        id: "client_secret",
                        placeholder: "クライアント秘密キー",
                        onChange: (e) => handleBindValue(e),
                        maxLength: 255,
                        value: data.client_secret ?? "",
                        type: "text",
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </Box>
              <Box sx={{ mt: 3 }}>
                <GridContainer spacing={3} direction="row">
                  <GridItem xs={12}>
                    <InputLabel className="text-grey">リフレッシュトークン</InputLabel>
                    <CustomInput
                      success={isEmpty(error.refresh_token)}
                      error={!isEmpty(error.refresh_token)}
                      helperText={error.refresh_token}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        id: "refresh_token",
                        placeholder: "リフレッシュトークン",
                        onChange: (e) => handleBindValue(e),
                        maxLength: 255,
                        value: data.refresh_token ?? "",
                        type: "text",
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </Box>
              <Box sx={{ mt: 3 }}>
                <GridContainer
                  direction="row"
                  alignItems="flex-end"
                  justifyContent="flex-end"
                >
                  <GridItem>
                    <LoadingButton
                      color="secondary"
                      disabled={enableBtn()}
                      loading={isLoadingBtn}
                      loadingPosition="start"
                      startIcon={<SaveIcon />}
                      variant="contained"
                      onClick={handleUpdate}
                    >
                      保存
                    </LoadingButton>
                  </GridItem>
                </GridContainer>
              </Box>
            </CardBody>
          </Card>
          <Taishou
            is_realtime_trans={data.is_realtime_trans}
            company_id={data.company_id}
            isProcess={isProcess}
            onChange={(data) => handleUpdateSwitch(data)}
          ></Taishou>
        </GridItem>
      </GridContainer>
    </>
  );
}
